import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { save, load } from 'redux-localstorage-simple'
import rootReducer from '../reducers'

const loggerMiddleware = createLogger()

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        applyMiddleware(
            thunk,
            save({
                states: ['UserData.session'],
                namespace: 'settings_page',
            }),
            loggerMiddleware
        )
    )
}
